import { render, staticRenderFns } from "./LingduiList.vue?vue&type=template&id=8fda3096&scoped=true&"
import script from "./LingduiList.vue?vue&type=script&lang=js&"
export * from "./LingduiList.vue?vue&type=script&lang=js&"
import style0 from "./LingduiList.vue?vue&type=style&index=0&id=8fda3096&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fda3096",
  null
  
)

export default component.exports